import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const umamiAnalyticsPlugin = createPlugin({
  id: 'umami-analytics',
  routes: {
    root: rootRouteRef,
  },
});

export const UmamiAnalyticsPage = umamiAnalyticsPlugin.provide(
  createRoutableExtension({
    name: 'UmamiAnalyticsPage',
    component: () =>
      import('./components/pages/UmamiAnalyticsPage').then(m => m.UmamiAnalyticsPage as any),
    mountPoint: rootRouteRef,
  }),
);
